import React from 'react';
import Main from 'modules/home/Main';
import DashHeader from 'modules/dashboard/_common/DashHeader';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import { Row } from 'styled/alignment/Row';
import HomeWrapper from './HomeWrapper';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';

export default function Home() {
    return (
        <HomeWrapper>
            <ContentHeader>
                <DashHeader />
                <DashHeaderActions />
            </ContentHeader>
            <Main />
        </HomeWrapper>
    );
}

const ContentHeader = styled(Row)`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;
